import { render, staticRenderFns } from "./CascadingElements.vue?vue&type=template&id=1fd54614"
import script from "./CascadingElements.vue?vue&type=script&lang=js"
export * from "./CascadingElements.vue?vue&type=script&lang=js"
import style0 from "./CascadingElements.vue?vue&type=style&index=0&id=1fd54614&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports